import { render, staticRenderFns } from "./CreateNewSimulationTemplate.vue?vue&type=template&id=4f4165dc&scoped=true&"
import script from "./CreateNewSimulationTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateNewSimulationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewSimulationTemplate.vue?vue&type=style&index=0&id=4f4165dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4165dc",
  null
  
)

export default component.exports